import React from 'react'
import './work.css'
import ByonyksLogo from '../../assests/Byonyks.jpeg'
import MercorLogo from '../../assests/mercor.jpeg'
import TuringLogo from '../../assests/Turing.png'
import GoogleLogo from '../../assests/Google.jpg'
import FiverrLogo from '../../assests/Fiverr.jpg'

const workData = [
  {
    logo: ByonyksLogo,
    company: "Byonyks",
    roles: [
      {
        position: "Senior Software Engineer",
        type: "Full Time, Pakistan",
        start: "2026-09",
        tags: []
      },
      {
        position: "Software Engineer",
        type: "Full Time, Pakistan",
        start: "2023-09",
        end: "2026-08",
        tags: ["Embedded Systems", "Software - Hardware Integration", "Medical Devices", "Modern C++", "FDA 510(k) Cleared", "Performance Award"]
      }
    ]
  },
  {
    logo: MercorLogo,
    company: "Mercor",
    roles: [
      {
        position: "Independent Contractor",
        type: "Contract, Remote",
        start: "2026-03",
        end: "2026-05",
        tags: ["AI Model Training", "Top Performer Expert", "100% Approval Rate", "International Client Relations", "Supervised Fine-Tuning (SFT) and RLHF pipelines"]
      }
    ]
  },
  {
    logo: TuringLogo,
    company: "Turing",
    roles: [
      {
        position: "AI - LLM Trainer",
        type: "Contract, Remote",
        start: "2025-09",
        end: "2026-02",
        tags: ["LLM Trainer", "Multi-turn AI", "Tool Calling"]
      }
    ]
  },
  {
    logo: FiverrLogo,
    company: "Fiverr",
    roles: [
      {
        position: "C++ Developer",
        type: "Freelance, Remote",
        start: "2020-08",
        end: "2023-08",
        tags: ["50+ Orders", "5-Star Rated", "International Client Relations", "10+ Countries"]
      }
    ]
  },
  {
    logo: GoogleLogo,
    company: "Google",
    roles: [
      {
        position: "GDSC Lead",
        type: "Volunteer",
        start: "2022-08",
        end: "2023-07",
        tags: ["International Community Lead", "Developer Events", "Google Badge"]
      }
    ]
  }
]

const monthFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  year: 'numeric',
  timeZone: 'UTC'
})

const parseMonth = (value) => {
  const [year, month] = value.split('-').map(Number)
  return { year, month }
}

const formatMonth = (value) => {
  const { year, month } = parseMonth(value)
  return monthFormatter.format(new Date(Date.UTC(year, month - 1, 1)))
}

const formatDuration = (start, end) => {
  const startMonth = parseMonth(start)
  const today = new Date()
  const endMonth = end
    ? parseMonth(end)
    : { year: today.getFullYear(), month: today.getMonth() + 1 }
  const totalMonths = Math.max(
    1,
    (endMonth.year - startMonth.year) * 12 + endMonth.month - startMonth.month + 1
  )
  const years = Math.floor(totalMonths / 12)
  const months = totalMonths % 12
  const parts = []

  if (years) parts.push(`${years} yr${years === 1 ? '' : 's'}`)
  if (months) parts.push(`${months} mo${months === 1 ? '' : 's'}`)

  return parts.join(' ')
}

const Role = ({ position, type, start, end, tags = [], isTimeline, showType }) => (
  <div className={isTimeline ? 'work__role work__role--timeline' : 'work__role'}>
    {isTimeline && <span className='work__timeline-dot' aria-hidden='true' />}
    <div className='work__role-heading'>
      <div>
        <h4 className='work__position'>{position}</h4>
        {showType && <span className='work__type'>{type}</span>}
      </div>
      <span className='work__role-duration'>
        {formatMonth(start)} - {end ? formatMonth(end) : 'Present'} · {formatDuration(start, end)}
      </span>
    </div>
    {tags.length > 0 && (
      <div className='work__tags'>
        {tags.map((tag) => (
          <span className='work__tag' key={tag}>{tag}</span>
        ))}
      </div>
    )}
  </div>
)

const Work = () => {
  return (
    <section id='work'>
      <h5>Where I've Worked</h5>
      <h2>Professional Journey</h2>

      <div className='container work__container'>
        {workData.map(({ logo, company, roles }) => {
          const hasMultipleRoles = roles.length > 1

          return (
            <article className='work__card' key={company}>
              <div className='work__logo-wrapper'>
                <img src={logo} alt={company} className='work__logo' />
              </div>
              <div className='work__info'>
                <div className='work__header'>
                  <h3 className='work__company'>{company}</h3>
                </div>
                <div className={hasMultipleRoles ? 'work__roles work__roles--timeline' : 'work__roles'}>
                  {roles.map((role, index) => (
                    <Role
                      {...role}
                      isTimeline={hasMultipleRoles}
                      showType={index === 0 || role.type !== roles[index - 1].type}
                      key={`${role.position}-${role.start}`}
                    />
                  ))}
                </div>
              </div>
            </article>
          )
        })}
      </div>
    </section>
  )
}

export default Work
